import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TsaService} from '../_services/tsa.service';
import {Globals} from '../globals';
import {formatDate} from '@angular/common';
import {UIChart} from 'primeng/chart';

@Component({
  selector: 'app-yoy',
  templateUrl: './yoy.component.html',
  styleUrls: ['./yoy.component.css']
})
export class YoyComponent implements OnInit {

  @Input() params: string = '';
  @Input() lineCode: string = '';
  @Input() startDate: any;
  @Input() endDate: any;
  @Input() latestActual: string = '';
  @Output() dataEvent = new EventEmitter<any>();
  @ViewChild('chart') chart: UIChart | undefined;
  chartOptions: any;
  chartWidth = '90vw';
  chartHeight = '65vh';
  chartData: any;
  loading = false;

  constructor(private service: TsaService, private globals: Globals) {
    // Set up chart options
    // reference to the same object
    this.chartOptions = this.globals.chartOptions;
  }

  ngOnInit(): void {
    if (window.innerWidth < 500) this.chartWidth = '95vw';
    this.updateService('/Query.action?sql=SQL_TSA_YOY_THROUGHPUT' + this.lineCode + this.params);
  }

  /**
   * Refresh data for the YOY chart
   * @param url - URL for getting the data
   */
  updateService(url: string): void {
    // Get data for the YOY chart
    this.service.url = url;
    this.loading = true;
    this.service.getData().subscribe((data: any[]) => {
      this.loading = false;
      this.dataEvent.emit(data);
      const x = [];
      let y: any[] = [];
      const est = [];
      let thisYear = Number(this.latestActual.substring(0, 4));
      let firstYear = this.startDate.getFullYear();
      let lastYear = this.endDate.getFullYear();
      for(let i=firstYear; i<=Math.min(thisYear,lastYear); i++) {
        y.push(new Array());
      }

      let months: any = {
        'Jan': '01',
        'Feb': '02',
        'Mar': '03',
        'Apr': '04',
        'May': '05',
        'Jun': '06',
        'Jul': '07',
        'Aug': '08',
        'Sep': '09',
        'Oct': '10',
        'Nov': '11',
        'Dec': '12'
      }
      let prevDate = '2200-01-01';
      for (const item of data) {
        let interDays = (new Date(item.DATE).getTime() - new Date(prevDate).getTime()) / (1000 * 3600 * 24);
        if (interDays > 1.1) {
          // Fill nulls if the date is not continuous
          for (let i=new Date(prevDate).getTime();
               i<new Date(item.DATE).getTime(); i += 1000 * 3600 * 24) {
            x.push(formatDate(i, "MMM dd", 'en-US'));
            for(let i=firstYear; i<=Math.min(thisYear,lastYear); i++) {
              y[i - firstYear].push(null);
            }
          }
        }
        prevDate = item.DATE;

        x.push(item.DATE);
        for(let i=firstYear; i<Math.min(thisYear,lastYear); i++) {
          let value = item['Y' + i];
          y[i - firstYear].push(value);
        }
        if(lastYear < thisYear) {
          y[lastYear - firstYear].push(item['Y'+lastYear]);
        } else {
          // Added forecast
          let value = item['Y' + thisYear];
          if (thisYear + '-' + months[item.DATE.substring(0, 3)] + '-' + item.DATE.substring(4, 6) >= this.latestActual) {
            est.push(value);
            // Add one point to connect two lines
            if (thisYear + '-' + months[item.DATE.substring(0, 3)] + '-' + item.DATE.substring(4, 6) > this.latestActual) {
              y[thisYear - firstYear].push(null);
            } else {
              y[thisYear - firstYear].push(value);
            }
          } else {
            y[thisYear - firstYear].push(value);
            // ADD MORE WHEN FORECAST IS ON THE NEXT YEAR
            if (item['Y' + (thisYear + 1)]) {
              est.push(item['Y' + (thisYear + 1)]);
            } else {
              est.push(null);
            }
          }
        }
      }
      let ds = [];
      for(let i=Math.min(lastYear,thisYear); i>=firstYear; i--) {
        let color = this.globals.getColor(i-firstYear);
        ds.push({
          label: i.toString(),
          fill: false,
          data: y[i-firstYear]
        });
      }
      if(this.endDate.getTime() > new Date(this.latestActual).getTime()) { // + (1000 * 3600 * 24)) {
        let color = this.globals.getColor(0);
        ds.push({
          label: 'Forecast',
          fill: false,
          borderColor: color,
          pointBorderColor: color,
          pointBackgroundColor: color,
          pointHoverBorderColor: color,
          pointHoverBackgroundColor: color,
          data: est
        })
      }
      this.chartData = {
        labels: x,
        datasets: ds
      };

      // Show points when there are less than 10 data points. Otherwise, single day data won't display.
      this.globals.dataPoints(this.chart, x.length);
    });
  }

  /**
   * Enable or disable zoom and pan function
   */
  changeZoomPan() {
    if(this.chart) {
      this.chart.options.plugins.zoom.zoom.enabled = !this.chart.options.plugins.zoom.zoom.enabled;
      this.chart.options.plugins.zoom.pan.enabled = !this.chart.options.plugins.zoom.pan.enabled;
      this.chart.options.plugins.zoom.zoom.speed = 0.01;
      this.chart.reinit();
    }
  }

}
